function initAcc() {
    var elements = document.getElementsByClassName('accordion');
    for (var i = 0; i < elements.length; i++) {
        elements[i].addEventListener('click', function (e) {
            if (!e.target.parentElement.classList.contains('accordion__active')) {
                e.target.parentElement.classList.add('accordion__active');
            } else {
                e.target.parentElement.classList.remove('accordion__active');
            }
        });
    }
}

initAcc()

